export default __webpack_public_path__ + "videos/topFilm.mp4";